import { Component } from 'react'
import type { ReactNode } from 'react'
import { StartupFallback } from '@/pwa/startup-fallback'

export class AppErrorBoundary extends Component<
  { children: ReactNode },
  { error: unknown; failed: boolean }
> {
  state = { error: null, failed: false }

  static getDerivedStateFromError(error: unknown) {
    return { error, failed: true }
  }

  render() {
    return this.state.failed ? (
      <StartupFallback error={this.state.error} />
    ) : (
      this.props.children
    )
  }
}
